
<div class="form" on:click>
    <div class="image">
        <img class="icon" src="/images/icon-plus-square.svg" alt="">
    </div>
    <div class="name">Formulario no sincronizado</div>
</div>

<style lang="scss">

    @use '../variables';

    .form {
        padding: 0.5rem;
        max-width: 125px;
    }

    .image {
        position: relative;
        background-color: variables.$color-neutral;
        border-radius: 1rem;
        aspect-ratio: 1;
    }

    .icon {
            position: absolute;
            top: 0.5rem;
            right: 0.5rem;
        }

    .name {
        text-transform: uppercase;
        font-size: 0.8rem;
        line-height: 1.2;
    }

    .acronym {
        position: absolute;
        bottom: 0.5rem;
        left: 0.5rem;
    }

</style>
